import { useAddAppointmentNoteMutation } from "../../../../../../../api/appointments/useAddAppointmentNoteMutation";
import { uiNotification } from "../../../../../../../services/UINotificationService";
import { useContext } from "../context";

export function useUpdateNote() {
  const { appointment } = useContext();

  const { mutateAsync, isLoading } = useAddAppointmentNoteMutation({
    onError: () => {
      uiNotification.error("Unable to update note. Try again later.");
    },
    onSuccess: () => {
      uiNotification.success("Note updated successfully.");
    },
  });

  return {
    initiate: ({ note }) => {
      return mutateAsync({
        appointmentId: appointment.id,
        note,
      });
    },
    isLoading,
  };
}
